var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33325 11.6666H5.33325M5.33325 13.6666H1.33325",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 11.6666H14.6667M14.6667 13.6666H10.6667",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 8H7V10.6667H9V8Z",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 4.66671C11.3334 6.50765 9.84101 8.00004 8.00008 8.00004C6.15913 8.00004 4.66675 6.50765 4.66675 4.66671C4.66675 2.82576 6.15913 1.33337 8.00008 1.33337C9.84101 1.33337 11.3334 2.82576 11.3334 4.66671Z",
    stroke: "#2E2C27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.66663L9 3.66663",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33325 10.6666H6.66659C6.03805 10.6666 5.72378 10.6666 5.52851 10.8619C5.33325 11.0572 5.33325 11.3714 5.33325 12V13.3333C5.33325 13.9618 5.33325 14.2761 5.52851 14.4714C5.72378 14.6666 6.03805 14.6666 6.66659 14.6666H9.33325C9.96179 14.6666 10.2761 14.6666 10.4713 14.4714C10.6666 14.2761 10.6666 13.9618 10.6666 13.3333V12C10.6666 11.3714 10.6666 11.0572 10.4713 10.8619C10.2761 10.6666 9.96179 10.6666 9.33325 10.6666Z",
    stroke: "#2E2C27",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipeline);
export default __webpack_public_path__ + "static/media/pipeline.fe220164ff46afc8cdb57d2e2597c9e7.svg";
export { ForwardRef as ReactComponent };